var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.5 107.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fddf64;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.75,0C24.11,0,0,24.11,0,53.75s24.11,53.75,53.75,53.75,53.75-24.11,53.75-53.75S83.39,0,53.75,0ZM75.53,28.31h-6.42c-6.33,0-8.3,3.92-8.3,7.95v9.55h14.12l-2.26,14.72h-11.86v35.58c-2.59.41-5.25.62-7.96.62s-5.36-.21-7.96-.62v-35.58h-12.93v-14.72h12.93v-11.22c0-12.76,7.6-19.81,19.23-19.81,5.57,0,11.4.99,11.4.99v12.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.23d175e068030183866491a6cc173396.svg";
export { ForwardRef as ReactComponent };